import { render, staticRenderFns } from "./drbalance.vue?vue&type=template&id=da90663c&scoped=true&"
import script from "./drbalance.vue?vue&type=script&lang=js&"
export * from "./drbalance.vue?vue&type=script&lang=js&"
import style0 from "./drbalance.vue?vue&type=style&index=0&id=da90663c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da90663c",
  null
  
)

export default component.exports